import React from 'react'
import CustomButton from './CustomButton'
import { Modal } from 'antd'
import { useUpdateUserDetailMutation } from '../redux/features/settings/settingApi';
import Toast from 'utils/Toast';

const TermsModal = ({ termsModal, setTermsModal }) => {
    const [updateUser, { isLoading }] = useUpdateUserDetailMutation();

    const handleUpdateProfile = async () => {
        try {
            const res = await updateUser({ is_registerd: "false" }).unwrap();
            if (res) {
                setTermsModal(false);
            }
        } catch (error) {
            Toast("e", error?.data?.message ?? error?.status);
        }
    };
    return (
        <>
            <Modal open={termsModal} closable={false} footer='' centered width={700}>
                <div className="p-4 bg-white rounded shadow-sm">
                    <h2 className="h3 font-weight-bold text-dark mb-4">TERMS OF USE</h2>

                    {/* Do Not Copy Section */}
                    <div className="mb-4">
                        <h3 className="h5 text-danger d-flex align-items-center mb-2">
                            <span role="img" aria-label="Do Not Copy">🚫</span> Do Not Copy
                        </h3>   
                        <p className="text-muted mb-2">
                            All PFI curriculum, sessions, and training materials are copyrighted intellectual property.
                        </p>
                        <p className="text-muted">
                            You are <strong>not permitted</strong> to distribute, repost, reproduce, or reuse this material in any way — including sharing it outside the app. <br />
                            We track misuse and will take <strong>legal action</strong> against any unauthorized use or duplication.
                        </p>
                    </div>

                    {/* Do Not Share Your Account Section */}
                    <div className="mb-4">
                        <h3 className="h5 text-danger d-flex align-items-center mb-2">
                            <span role="img" aria-label="Do Not Share">🚫</span> Do Not Share Your Account
                        </h3>
                        <p className="text-muted mb-2">
                            Premier Futbol Institute is licensed per team, and <strong>sharing logins across multiple teams or coaches</strong> violates our Terms of Use.
                        </p>
                        <p className="text-muted">
                            We actively monitor login behavior and <strong>account sharing will be flagged</strong>. If you’re caught account sharing, your access will be
                            <strong className="text-danger"> revoked permanently without refund</strong>.
                        </p>
                    </div>

                    {/* Why This Matters Section */}
                    <div className="mb-4">
                        <h3 className="h5 text-dark mb-2">Why This Matters:</h3>
                        <p className="text-muted mb-2">
                            Every subscription directly supports our mission to <em>‘Level the Pitch’</em> — helping make world-class training accessible to players regardless of geography or income.
                        </p>
                        <p className="text-muted">
                            When you pay for your team’s license, you’re not just unlocking access to PFI —
                            <strong> you’re helping to grow youth development around the world</strong>.
                        </p>
                    </div>

                    {/* Agree Button */}
                    <div className="text-center mt-4">
                        <CustomButton
                            loading={isLoading}
                            onClick={handleUpdateProfile}
                            style={{ background: `var(--btn-gray)`, color: `var(--black)` }}
                        >
                            I Agree
                        </CustomButton>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default TermsModal